import { GET_ACCESS_GROUPS, GET_PARTNER_CLIENT_ACCOUNT } from '../../actions/get';
import Preloader from '../../components/global/Preloader';
import TabPanelBackLink from '../../components/global/tab/TabPanelBackLink';
import TabPanelLayout from '../../components/global/tab/TabPanelLayout';
import { PageContext } from '../../context/pages';
import { AntTab, AntTabs, useStyles } from '../../theme/Tabs';
import { AntContainerHead } from '../../theme/Wrapper';
import DnsHosting from './dnsHosting/Component';
import GeneralAccount from './generalAccount';
import L7ProtectionAccount from './l7ProtectionAccount';
import NetworkProtectionV2 from './networkProtectionV2';
import UsersAndGroups from './usersAndGroups';
import { accessGroupTabs, getAccessGroupPath, getUsersAndGroupsPath } from './usersAndGroups/store';
import { useQuery } from '@apollo/client';
import React, { useContext, useEffect, useState } from 'react';
import { NavLink, useLocation, useParams } from 'react-router-dom';

const AccountEdit = () => {
  const classes = useStyles();
  const { tab, id, userId, groupId, accessTab } = useParams();
  const location = useLocation();
  const [indexTab, setIndexTab] = useState(0);
  const { deleteFilter } = useContext(PageContext);

  const handleChange = (event, newValue) => {
    setIndexTab(newValue);
  };

  const a11yProps = (index) => {
    return {
      id: `simple-tab-${index}`,
      'aria-controls': `simple-tabpanel-${index}`,
    };
  };

  useEffect(() => {
    setIndexTab(Number(tab));
  }, [tab]);

  const { data, loading } = useQuery(GET_PARTNER_CLIENT_ACCOUNT, {
    variables: {
      id: Number(id),
    },
  });

  const { data: accessGroupData } = useQuery(GET_ACCESS_GROUPS, {
    variables: {
      filterId: Number(groupId),
      filterPartnerClientAccountId: Number(id),
      limit: 1,
      page: 1,
      deletedAt: null,
    },
    skip: !groupId || !id,
  });

  const usersCount = accessGroupData?.accessGroups?.items?.[0]?.usersCount;
  const usersTabTitle = usersCount > 0 ? `Users (${usersCount})` : 'Users';
  const groupTabs = [
    { key: accessGroupTabs.general, label: 'General' },
    { key: accessGroupTabs.users, label: usersTabTitle },
    { key: accessGroupTabs.networkProtection, label: 'Network protection' },
    { key: accessGroupTabs.applicationProtection, label: 'Application protection' },
    { key: accessGroupTabs.dnsHosting, label: 'DNS hosting' },
  ];
  const groupTabIndex = Math.max(
    0,
    groupTabs.findIndex((groupTab) => groupTab.key === accessTab)
  );

  if (loading) return <Preloader />;

  const backLinkTo = userId
    ? `${getUsersAndGroupsPath(id)}?tab=users`
    : groupId
      ? `${getUsersAndGroupsPath(id)}?tab=accessGroups`
      : '/accounts';
  const backLinkText = userId ? 'user' : groupId ? 'group' : 'account';

  return (
    <>
      <div position="static" className={classes.bar}>
        <AntContainerHead maxWidth={false}>
          <TabPanelBackLink
            to={backLinkTo}
            edit="Edit"
            text={backLinkText}
            useFromState={!userId && !groupId}
          />
          {userId ? (
            <AntTabs value={0} className={classes.itemTab}>
              <AntTab label="General" />
            </AntTabs>
          ) : groupId ? (
            <AntTabs
              value={groupTabIndex}
              className={classes.itemTab}
              variant="scrollable"
              scrollButtons="auto"
            >
              {groupTabs.map((groupTab, index) => (
                <AntTab
                  key={groupTab.key}
                  label={groupTab.label}
                  {...a11yProps(index)}
                  to={getAccessGroupPath(id, groupId, groupTab.key)}
                  component={NavLink}
                  replace
                  end
                />
              ))}
            </AntTabs>
          ) : (
            <AntTabs
              value={indexTab}
              onChange={handleChange}
              className={classes.itemTab}
              variant="scrollable"
              scrollButtons="auto"
            >
              <AntTab
                label="general"
                {...a11yProps(0)}
                to={`/edit-account/0/${id}`}
                component={NavLink}
                replace
                state={location.state}
                onClick={() => deleteFilter()}
              />
              <AntTab
                label="Users and Groups"
                {...a11yProps(1)}
                to={`/edit-account/1/${id}`}
                component={NavLink}
                replace
                state={location.state}
                onClick={() => deleteFilter()}
              />
              <AntTab
                label="Application Protection"
                {...a11yProps(2)}
                to={`/edit-account/2/${id}`}
                component={NavLink}
                replace
                state={location.state}
                onClick={() => deleteFilter()}
              />
              <AntTab
                label="DNS hosting"
                {...a11yProps(3)}
                to={`/edit-account/3/${id}/0`}
                component={NavLink}
                replace
                state={location.state}
                onClick={() => deleteFilter()}
              />
              <AntTab
                label="Network protection v 2.0"
                {...a11yProps(4)}
                to={`/edit-account/4/${id}`}
                component={NavLink}
                replace
                state={location.state}
                onClick={() => deleteFilter()}
              />
            </AntTabs>
          )}
        </AntContainerHead>
      </div>
      <TabPanelLayout value={indexTab} index={0}>
        <GeneralAccount partnerClientAccount={data && data.partnerClientAccount} />
      </TabPanelLayout>
      <TabPanelLayout value={indexTab} index={1}>
        <UsersAndGroups />
      </TabPanelLayout>
      <TabPanelLayout value={indexTab} index={2}>
        <L7ProtectionAccount dataPartnerClientAccount={data && data.partnerClientAccount} />
      </TabPanelLayout>
      <TabPanelLayout value={indexTab} index={3}>
        <DnsHosting dataPartnerClientAccount={data && data.partnerClientAccount} />
      </TabPanelLayout>
      <TabPanelLayout value={indexTab} index={4}>
        <NetworkProtectionV2 />
      </TabPanelLayout>
    </>
  );
};
export default AccountEdit;
